import { useEffect, useState } from "react";
import api from "@/lib/api";
import EmailLogsPanel from "@/components/EmailLogsPanel";
import EmailTemplatesPanel from "@/components/EmailTemplatesPanel";
import { History, FileEdit } from "lucide-react";

const VIEWS = [
  { id: "logs", label: "Historique des envois", icon: History },
  { id: "templates", label: "Modèles d'email", icon: FileEdit },
];

export default function EmailCenter() {
  const [view, setView] = useState("logs");
  const [templates, setTemplates] = useState([]);
  const load = () => api.get("/admin/email-templates").then((r) => setTemplates(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-6" data-testid="email-center">
      <div className="flex flex-wrap gap-2">
        {VIEWS.map((v) => (
          <button key={v.id} data-testid={`email-view-${v.id}`} onClick={() => setView(v.id)} className={`flex items-center gap-1.5 px-5 py-2 text-sm rounded-full border transition-colors ${view === v.id ? "bg-[#1B2A4A] text-white border-[#1B2A4A]" : "bg-white text-[#1B2A4A] border-gray-300 hover:border-[#1B2A4A]"}`}>
            <v.icon className="w-4 h-4" /> {v.label}
          </button>
        ))}
      </div>
      {view === "logs" ? <EmailLogsPanel templates={templates} /> : <EmailTemplatesPanel templates={templates} reload={load} />}
    </div>
  );
}
